(() => {
  'use strict';

  const modal = document.getElementById('JakPrecheckoutModal');
  if (!modal || modal.dataset.ready === 'true') return;

  modal.dataset.ready = 'true';

  const form = modal.querySelector('#JakPrecheckoutForm');
  const identificationInput = modal.querySelector('#JakPrecheckoutId');
  const companyNote = modal.querySelector('#JakPrecheckoutCompanyNote');
  const errorElement = modal.querySelector('#JakPrecheckoutError');
  const submitButton = modal.querySelector('[data-jak-precheckout-submit]');
  const submitLabel = modal.querySelector('[data-jak-precheckout-submit-label]');
  const closeButtons = modal.querySelectorAll('[data-jak-precheckout-close]');
  const dialog = modal.querySelector('.jak-precheckout__dialog');

  const cartJsonUrl = modal.dataset.cartJsonUrl || '/cart.js';
  const cartUpdateUrl = modal.dataset.cartUpdateUrl || '/cart/update.js';
  const checkoutUrl = modal.dataset.checkoutUrl || '/checkout';

  const checkoutSelector = [
    '[data-jak-buybar-buy]',
    '.shopify-payment-button__button',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#checkout',
    '#CartDrawer-Checkout',
    '.cart__checkout-button',
    'a[href*="/checkout"]',
  ].join(',');

  let pendingAction = null;
  let resumeGuard = false;
  let loading = false;
  let lastFocusedElement = null;
  let cartLoadSequence = 0;

  const getBuyerType = () =>
    form.querySelector('input[name="jak_buyer_type"]:checked')?.value || '';

  const setBuyerType = (value) => {
    const matching = form.querySelector(
      `input[name="jak_buyer_type"][value="${
        value === 'Empresa' ? 'Empresa' : 'Persona natural'
      }"]`
    );

    if (matching) matching.checked = true;
    updateCompanyNote();
  };

  const updateCompanyNote = () => {
    companyNote.hidden = getBuyerType() !== 'Empresa';
  };

  const normalizeIdentification = (value) =>
    String(value || '')
      .trim()
      .replace(/\s+/g, ' ');

  const validateIdentification = (value) => {
    const normalized = normalizeIdentification(value);
    const digits = normalized.replace(/\D/g, '');

    if (!normalized) {
      return 'Ingresa la cédula o el NIT para continuar.';
    }

    if (!/^[0-9.\-\s]+$/.test(normalized)) {
      return 'Usa únicamente números, puntos, espacios o guion.';
    }

    if (digits.length < 5) {
      return 'Revisa el número ingresado. Debe contener al menos 5 dígitos.';
    }

    if (normalized.length > 20) {
      return 'La cédula o el NIT no puede superar los 20 caracteres.';
    }

    return '';
  };

  const showError = (message) => {
    errorElement.textContent = message || '';
    errorElement.hidden = !message;
    identificationInput.setAttribute(
      'aria-invalid',
      message ? 'true' : 'false'
    );
  };

  const setLoading = (nextLoading) => {
    loading = Boolean(nextLoading);
    modal.classList.toggle('is-loading', loading);
    submitButton.disabled = loading;

    closeButtons.forEach((button) => {
      button.disabled = loading;
    });

    submitLabel.textContent = loading
      ? 'Guardando datos…'
      : 'Continuar al pago';
  };

  const showModal = () => {
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('jak-precheckout-open');

    requestAnimationFrame(() => {
      modal.classList.add('is-open');

      window.setTimeout(() => {
        identificationInput.focus({ preventScroll: true });
      }, 180);
    });
  };

  const closeModal = ({
    restoreFocus = true,
    clearAction = true,
  } = {}) => {
    if (loading) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('jak-precheckout-open');

    window.setTimeout(() => {
      modal.hidden = true;
      showError('');

      if (clearAction) {
        pendingAction = null;
      }

      if (restoreFocus && lastFocusedElement?.isConnected) {
        lastFocusedElement.focus({ preventScroll: true });
      }
    }, 220);
  };

  const fetchCartAttributes = async () => {
    const sequence = ++cartLoadSequence;

    try {
      const response = await fetch(cartJsonUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) return;

      const cart = await response.json();

      if (sequence !== cartLoadSequence) return;

      const attributes = cart.attributes || {};
      const savedType = attributes['Tipo de comprador'];
      const savedIdentification = attributes['Cédula o NIT'];

      if (
        savedType === 'Empresa' ||
        savedType === 'Persona natural'
      ) {
        setBuyerType(savedType);
      }

      if (
        savedIdentification &&
        !identificationInput.value.trim()
      ) {
        identificationInput.value = savedIdentification;
      }
    } catch (error) {
      console.warn(
        'Jak Store: no fue posible precargar los datos de facturación.',
        error
      );
    }
  };

  const saveCartAttributes = async (
    buyerType,
    identification
  ) => {
    const response = await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          'Tipo de comprador': buyerType,
          'Cédula o NIT': identification,
        },
      }),
    });

    let payload = null;

    try {
      payload = await response.json();
    } catch (error) {
      payload = null;
    }

    if (!response.ok) {
      throw new Error(
        payload?.description ||
          payload?.message ||
          'No fue posible guardar los datos. Intenta nuevamente.'
      );
    }

    return payload;
  };

  const upsertHiddenInput = (
    productForm,
    name,
    value
  ) => {
    if (!productForm) return;

    let input = Array.from(
      productForm.elements || []
    ).find((element) => element.name === name);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      productForm.appendChild(input);
    }

    input.value = value;
  };

  const getProductFormForAction = (action) => {
    const element = action?.element;

    if (!element) return null;

    if (element.matches('[data-jak-buybar-buy]')) {
      const buybar = element.closest(
        '[data-section-id]'
      );
      const sectionId = buybar?.dataset.sectionId;

      if (sectionId) {
        const sectionRoot = document.getElementById(
          `MainProduct-${sectionId}`
        );

        return (
          sectionRoot?.querySelector(
            'form[data-type="add-to-cart-form"]'
          ) ||
          sectionRoot?.querySelector(
            'product-form form'
          ) ||
          null
        );
      }
    }

    const closestForm = element.closest('form');

    if (
      closestForm &&
      (
        closestForm.matches(
          '[data-type="add-to-cart-form"]'
        ) ||
        closestForm.action.includes('/cart/add')
      )
    ) {
      return closestForm;
    }

    return null;
  };

  const injectPrivateProductProperties = (
    action,
    buyerType,
    identification
  ) => {
    const productForm =
      getProductFormForAction(action);

    if (!productForm) return;

    /*
      Respaldo para el botón dinámico "Comprar ahora":
      las propiedades privadas viajan con el producto
      y no se muestran como opciones visibles al cliente.
    */
    upsertHiddenInput(
      productForm,
      'properties[_Tipo de comprador]',
      buyerType
    );

    upsertHiddenInput(
      productForm,
      'properties[_Cédula o NIT]',
      identification
    );
  };

  const isDisabled = (element) =>
    Boolean(
      element?.disabled ||
        element?.getAttribute('aria-disabled') ===
          'true' ||
        element?.classList.contains('disabled')
    );

  const getCheckoutElement = (eventTarget) => {
    if (!(eventTarget instanceof Element)) {
      return null;
    }

    const candidate =
      eventTarget.closest(checkoutSelector);

    if (
      !candidate ||
      modal.contains(candidate) ||
      isDisabled(candidate)
    ) {
      return null;
    }

    if (
      candidate.matches('a[href*="/checkout"]')
    ) {
      const href =
        candidate.getAttribute('href') || '';

      if (!href.includes('/checkout')) {
        return null;
      }
    }

    return candidate;
  };

  const createClickAction = (element) => {
    if (
      element.matches('a[href*="/checkout"]')
    ) {
      return {
        kind: 'anchor',
        element,
        href: element.href,
      };
    }

    return {
      kind: 'element',
      element,
    };
  };

  const createSubmitAction = (
    formElement,
    submitter
  ) => ({
    kind: 'form',
    form: formElement,
    submitter: submitter || null,
    element: submitter || formElement,
  });

  const openForAction = (action) => {
    pendingAction = action;
    showError('');
    showModal();
    fetchCartAttributes();
  };

  const resumeAction = (action) => {
    if (!action) {
      window.location.assign(checkoutUrl);
      return;
    }

    resumeGuard = true;

    try {
      if (action.kind === 'anchor') {
        window.location.assign(
          action.href || checkoutUrl
        );
        return;
      }

      if (
        action.kind === 'form' &&
        action.form?.isConnected
      ) {
        if (
          typeof action.form.requestSubmit ===
          'function'
        ) {
          action.form.requestSubmit(
            action.submitter || undefined
          );
        } else {
          action.form.submit();
        }

        return;
      }

      if (
        action.element?.isConnected &&
        typeof action.element.click === 'function'
      ) {
        action.element.click();
        return;
      }

      window.location.assign(checkoutUrl);
    } finally {
      window.setTimeout(() => {
        resumeGuard = false;
      }, 120);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      if (resumeGuard) return;

      const checkoutElement =
        getCheckoutElement(event.target);

      if (!checkoutElement) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openForAction(
        createClickAction(checkoutElement)
      );
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (
        resumeGuard ||
        modal.contains(event.target)
      ) {
        return;
      }

      const submitter =
        event.submitter || null;

      const checkoutElement = submitter
        ? getCheckoutElement(submitter)
        : null;

      if (!checkoutElement) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openForAction(
        createSubmitAction(
          event.target,
          submitter
        )
      );
    },
    true
  );

  form.addEventListener('change', (event) => {
    if (
      event.target.matches(
        'input[name="jak_buyer_type"]'
      )
    ) {
      updateCompanyNote();
    }
  });

  identificationInput.addEventListener(
    'input',
    () => {
      if (!errorElement.hidden) {
        showError(
          validateIdentification(
            identificationInput.value
          )
        );
      }
    }
  );

  form.addEventListener(
    'submit',
    async (event) => {
      event.preventDefault();

      if (loading) return;

      const buyerType = getBuyerType();

      const identification =
        normalizeIdentification(
          identificationInput.value
        );

      const validationMessage =
        validateIdentification(
          identification
        );

      if (!buyerType) {
        showError(
          'Selecciona si la compra es para una persona o una empresa.'
        );
        return;
      }

      if (validationMessage) {
        showError(validationMessage);
        identificationInput.focus();
        return;
      }

      showError('');
      setLoading(true);

      const actionToResume = pendingAction;

      try {
        await saveCartAttributes(
          buyerType,
          identification
        );

        injectPrivateProductProperties(
          actionToResume,
          buyerType,
          identification
        );

        setLoading(false);

        closeModal({
          restoreFocus: false,
          clearAction: false,
        });

        window.setTimeout(() => {
          pendingAction = null;
          resumeAction(actionToResume);
        }, 230);
      } catch (error) {
        setLoading(false);

        showError(
          error?.message ||
            'No fue posible guardar los datos. Intenta nuevamente.'
        );
      }
    }
  );

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      closeModal();
    });
  });

  document.addEventListener(
    'keydown',
    (event) => {
      if (modal.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = Array.from(
        dialog.querySelectorAll(
          'button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'
        )
      ).filter(
        (element) =>
          !element.hidden &&
          element.offsetParent !== null
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last =
        focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    }
  );

  updateCompanyNote();
})();